module.exports = __webpack_public_path__ + "img/rescuericon.58077925.png";